<!-- <p>delete-user-account-dialog works!</p> -->
<div
  *ngIf="data.isDeleteOrganization && !data.isRemoving && !data.isDeleteAccount"
>
  <h1 mat-dialog-title>Delete Organization</h1>
  <mat-dialog-content class="mat-typography">
    <div class="remove-user-dialog-status">
      <strong>Do you really want to delete your Organization!</strong>
    </div>

    <mat-divider></mat-divider> </mat-dialog-content
  ><mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
    <button mat-raised-button [mat-dialog-close]="true">Delete</button>
  </mat-dialog-actions>
</div>

<div
  *ngIf="data.isDeleteAccount && !data.isRemoving && !data.isDeleteOrganization"
>
  <h1 mat-dialog-title>Delete Account</h1>
  <mat-dialog-content class="mat-typography">
    <div class="remove-user-dialog-status">
      <strong>Do you really want to delete your Account!</strong>
    </div>

    <mat-divider></mat-divider> </mat-dialog-content
  ><mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
    <button mat-raised-button [mat-dialog-close]="true">Delete</button>
  </mat-dialog-actions>
</div>
<div *ngIf="data.isRemoving">
  <h1 mat-dialog-title>
    Delete {{ data.isDeleteOrganization ? "Organization" : "Account" }}
  </h1>
  <mat-dialog-content class="mat-typography">
    <div class="remove-user-dialog-status">
      <i
        >Please wait while removing
        {{ data.isDeleteOrganization ? "Organization" : "Account" }} data!</i
      >
      <mat-divider></mat-divider>
      <mat-spinner></mat-spinner>
    </div>
  </mat-dialog-content>
</div>
